var selected_year='', selected_make='' , selected_model='' , selected_trim='' , selected_cab='';
var selected_equipemnt_type = ''  , selected_eq_manufacturer='' , selected_eq_model='';
var selectedPartNumber = [];
var vehicleJson = ''
var vehicleJsonFord , selected_year_vehicle,selectedPartNumberVehicle , part_numbers_vehicle , selected_trim_vehicle , selected_cab_vehicle ,selected_model_vehicle , selected_make_vehicle;

class CollectionFilters extends HTMLElement {

  constructor() {
    super();
    this.accordionType = this.dataset.accordiontype;
    this.filterParent = this.closest('#filtersCollapse');
    /*********** End of Open Drawer on Filter or SortBy button click. Close Drawer on close button click ********/
    this.sortby_values = document.querySelectorAll('[data-sortby] .sortby_options');
    this.sortby_values.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));
    this.pagination_value = document.querySelectorAll('[data-custom-pagination] .pagination_value');
    this.pagination_value.forEach(input => input.addEventListener('change', this.updatePagination.bind(this)));
    
    // this.filterParent.addEventListener('keyup', (event) => {
    //   if (event.code.toUpperCase() === 'ESCAPE'){ this.closeFilterDrawer.dispatchEvent(new Event('click')); }
    // });

    this._displaySelectedVehicle();
    this.debouncedOnSubmit = Utility.debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);
    
    const paginationLinks = document.querySelectorAll('[data-pagination]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    this.displayCurrentVehicleForm();

    this.filterForm = this.querySelectorAll('form');
    this.filterForm.forEach((form) => {
      if (form) {
        this.sortby_values.forEach(input => input.addEventListener('change', this.debouncedOnSubmit.bind(this)));
        document.querySelectorAll('[data-filterSubmit]').forEach(button => button.addEventListener('click', this.onSubmitHandler.bind(this)));
        window.addEventListener('popstate', this.onHistoryChange.bind(this));
      }
    });

    

    
  }


  /**
   * Collection filter form Input event
   * @param {event} event Event Instance
   */
  onSubmitHandler(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (event.type == 'input' && this.filterParent.classList.contains('filter-active')) {
      return;
    }

    let closestForm = document.getElementById('CollectionFiltersForm');
    if (event.target && event.target.closest('form')) { closestForm = event.target.closest('form'); }
    if (!closestForm) return;

    const searchParams = this._finalQueryString(closestForm)
    this.renderPage(searchParams);
    const min = 1000;
    const max = 5000;
    const randomNum = Math.floor(Math.random() * (max - min + 1)) + min;
    let selectedData;

    this.selectedTrufData = window.customerSelectedVehicles.turf;
    this.selectedYMMData = window.customerSelectedVehicles.vehicle;
    this.selectedHeavyEqipData =  window.customerSelectedVehicles.heavyVehicle;
    this.selectedSideYMMData = window.customerSelectedVehicles.sidebyside;
    this.selectedSAHDTYMMData = window.customerSelectedVehicles.sahdt

    let isCustomer = document.body.classList.contains('customer-loggedin');

    this.defaultVehicle = true;
    if(this.selectedYMMData.length > 0){
      this.selectedYMMData.forEach((selectedYMM) => {
          if(selectedYMM.default == true){
              this.defaultVehicle = false;
          }
      })
    } else if(this.selectedHeavyEqipData.length > 0){
      this.selectedHeavyEqipData.forEach((selectedHQ) => {
          if(selectedHQ.default == true){
              this.defaultVehicle = false;
          }
      })
    } else if(this.selectedSAHDTYMMData.length > 0){
        this.selectedSAHDTYMMData.forEach((vh) => {
            if(vh.default == true){
                this.defaultVehicle = false;
            }
        })
    } else if(this.selectedSideYMMData.length > 0){
      this.selectedSideYMMData.forEach((vh) => {
          if(vh.default == true){
              this.defaultVehicle = false;
          }
      })
    } else if(this.selectedTrufData.length > 0){
      this.selectedTrufData.forEach((vh) => {
          if(vh.default == true){
              this.defaultVehicle = false;
          }
      })
    } else {
      // Determine if it's the default vehicle
      this.defaultVehicle = this.selectedHeavyEqipData.length === 0;
   }
   

    let identifyCollection = document.querySelector('[data-grid-collection]').getAttribute('data-grid-collection');
    if (identifyCollection == 'seat-covers') {
      selectedData = {
        'year':selected_year,
        'make': selected_make,
        'model': selected_model,
        "id": randomNum,
        "trim": selected_trim,
        "cabType": selected_cab,
        "default": this.defaultVehicle,
        "active": true
      }

      this.selectedYMMData.push(selectedData);

      if(isCustomer){
        shopifyFormUtility._updateVehicleMeta(this.selectedYMMData);
      } else {
        localStorage.setItem('vehicle_data', JSON.stringify(this.selectedYMMData))
      }

    }
    else if (identifyCollection == 'equipment-seat-covers') {
      selectedData = {
        "id": randomNum,
        "equipment_category": selected_equipemnt_type,
        "equipment_manufacturer": selected_eq_manufacturer,
        "equipment_model_number": selected_eq_model,
        "default": this.defaultVehicle,
        "active": true
      }
      this.selectedHeavyEqipData.push(selectedData);

      if(isCustomer){
        shopifyFormUtility._updateCustomerHEMeta(this.selectedHeavyEqipData);
      } else {
        localStorage.setItem('heavy_equipment_data', JSON.stringify(this.selectedHeavyEqipData))
      }


    } else if(identifyCollection == 'tractor-lawn-mower-seat-covers'){
      selectedData = {
          "id": randomNum,
          "equipment_category":selected_equipemnt_type,
          "equipment_manufacturer":selected_eq_manufacturer,
          "equipment_model_number":selected_eq_model,
          "default":this.defaultVehicle
      }

      this.selectedTrufData.push(selectedData);

      if(isCustomer){
        shopifyFormUtility._updateCustomerTurfMeta(this.selectedTrufData);
      } else {
        localStorage.setItem('turf_data', JSON.stringify(this.selectedTrufData))
      }

     

    } else if(identifyCollection == 'semis-heavy-duty-trucks'){
      selectedData = {
        "id": randomNum,
        "year":selected_year,
        "make":selected_make,
        "model":selected_model,
        "default":this.defaultVehicle
      }
      this.selectedSAHDTYMMData.push(selectedData);

      if(isCustomer){
        shopifyFormUtility._updateCustomerSHeavyMeta(this.selectedSAHDTYMMData);
      } else {
        localStorage.setItem('vehicle_data_sahdt', JSON.stringify(this.selectedSAHDTYMMData));
      }



    } else if(identifyCollection == 'side-by-side-seat-covers'){
        selectedData = {
          "id": randomNum,
          "year":selected_year,
          "make":selected_make,
          "model":selected_model,
          "default": this.defaultVehicle,
          "active": true
        }
        this.selectedSideYMMData.push(selectedData);

        if(isCustomer){
          shopifyFormUtility._updateCustomerSideMeta(this.selectedSideYMMData);
        } else {
          localStorage.setItem('vehicle_data_side', JSON.stringify(this.selectedSideYMMData));
        }

    } else{
      selectedData = {
        'year': selected_year,
        'make': selected_make,
        'model': selected_model,
        "id": randomNum,
        "trim": selected_trim,
        "cabType": selected_cab, 
        "equipment_category": selected_equipemnt_type,
        "equipment_manufacturer": selected_eq_manufacturer,
        "equipment_model_number": selected_eq_model,
        "default": '',
        "active": true
      }
    }
    localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedData));
    if (identifyCollection == 'ford-f150') {
      let selectedDataVehicle;
      selectedDataVehicle = {
          'year':selected_year_vehicle || '',
          'make': 'f150',
          'model': 'ford',
          "default": '',
          "active": true
      }
      localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedDataVehicle));
    }

    vehicleUtility._deterMineVehicles();

    vehicleUtility._listVehicle()
    // if (identifyCollection == 'ford-f150') {
    //   let selectedDataVehicle;
    //   selectedDataVehicle = {
    //       'year':selected_year_vehicle || '',
    //       'make': 'f150',
    //       'model': 'ford',
    //       "default": '',
    //       "active": true
    //   }
    //   localStorage.setItem('currentSelectedDataLabels', JSON.stringify(selectedDataVehicle));
    // }

    
  }

  displayCurrentVehicleForm(){
    let selectedData = localStorage.getItem('currentSelectedDataLabels');
    let isequipment = false;
    let identifyCollection = document.querySelector('[data-grid-collection]').getAttribute('data-grid-collection');
    if (selectedData != null && selectedData != undefined){
      selectedData = JSON.parse(selectedData);
  
      selectedData?.equipment_manufacturer != '' && selectedData?.equipment_manufacturer != undefined ? isequipment = true : isequipment= false;
  
      if(isequipment && (identifyCollection == 'all' || identifyCollection == 'equipment-seat-covers')){
         document.querySelectorAll('[data-allfilters]').forEach( ele => {
            ele.classList.add('d-none')
          })
          document.querySelectorAll('[data-filter="equipment-type"],[data-filter="model-number"],[data-filter="manufacturer"]').forEach( ele => {
            ele.classList.remove('d-none')
          })
         document.querySelectorAll('[data-filter="year"],[data-filter="make"],[data-filter="model"]').forEach( ele => {
          ele.classList.add('d-none')
        })
      }
      else if((identifyCollection == 'all' || identifyCollection == 'seat-covers') && isequipment == false){
        document.querySelectorAll('[data-allfilters]').forEach( ele => {
          ele.classList.add('d-none')
        })
        document.querySelectorAll('[data-filter="year"],[data-filter="make"],[data-filter="model"]').forEach( ele => {
          ele.classList.remove('d-none')
        })
         document.querySelectorAll('[data-filter="equipment-type"],[data-filter="model-number"],[data-filter="manufacturer"]').forEach( ele => {
            ele.classList.add('d-none')
          })
      }
      else if((identifyCollection == 'all' || identifyCollection == 'seat-covers') && isequipment == true){
        document.querySelectorAll('[data-allfilters]').forEach( ele => {
          ele.classList.add('d-none')
        })
        document.querySelectorAll('[data-filter="year"],[data-filter="make"],[data-filter="model"]').forEach( ele => {
          ele.classList.remove('d-none')
        })
         document.querySelectorAll('[data-filter="equipment-type"],[data-filter="model-number"],[data-filter="manufacturer"]').forEach( ele => {
            ele.classList.add('d-none')
          })
      }
    } else {
      if((identifyCollection == 'all' || identifyCollection == 'seat-covers') && isequipment == false){
        document.querySelectorAll('[data-allfilters]').forEach( ele => {
          ele.classList.add('d-none')
        })
        document.querySelectorAll('[data-filter="year"],[data-filter="make"],[data-filter="model"]').forEach( ele => {
          ele.classList.remove('d-none')
        })
      }
    }
  }


  /**
   * 
   * current vehicle data
   */
  _displaySelectedVehicle(){
    let selectedData = localStorage.getItem('currentSelectedDataLabels');

    // Check for null, "undefined", "", or empty JSON structure as string
    if (
      !selectedData || 
      selectedData === 'undefined' || 
      selectedData.trim() === '' || 
      selectedData === '{"id":"","year":"","make":"","model":"","trim":"","cabType":""}'
    ) {
      selectedData = localStorage.getItem('currentSelectedData');
    }


    if (selectedData !== null && selectedData !== 'undefined' && selectedData !== '') {
      
      selectedData = JSON.parse(selectedData);
      let yearVal ='' ,makeVal='' , modelVal='' , trimValue='' , cabTypeVal='';
      let eqCat = '' , eqMan='' , eqModelnum='';

      if(selectedData){
        selectedData.year != undefined ? yearVal = selectedData.year : '' ;
        selectedData.make != undefined ? makeVal = selectedData.make :'';
        selectedData.model != undefined ? modelVal = selectedData.model :'';
        selectedData.trim != undefined ? trimValue = selectedData.trim : '';
        selectedData.cabType != undefined ? cabTypeVal = selectedData.cabType : '';
        selectedData.equipment_category != undefined ? eqCat = selectedData.equipment_category :'';
        selectedData.equipment_manufacturer != undefined ? eqMan = selectedData.equipment_manufacturer :'';
        selectedData.equipment_model_number != undefined ? eqModelnum = selectedData.equipment_model_number :'';
      }

      let trim_value = `${trimValue ? ',' + trimValue + ', ' + cabTypeVal : ''}`;
      let concatenatedData = `${yearVal} ${makeVal} ${modelVal}${trim_value} ${eqCat} ${eqMan} ${eqModelnum}`;

      if(document.querySelector('[data-activeFilters]')) 
      document.querySelector('[data-activeFilters]').innerHTML = concatenatedData;

      let isfiltered = document.querySelector('[data-filtered]').getAttribute('data-filtered');

      if(isfiltered == 'true'){
        document.querySelector('[ data-special-about]')?.classList.add('d-none');
        document.querySelector('[data-seat-cover-feature]')?.classList.add('d-none');
        document.querySelector('[data-index-reviews]')?.classList.add('d-none');
        document.querySelectorAll('[data-features-content]').forEach( ele => ele.classList.add('d-none'));
        document.querySelector('[data-features-content="quiz"]')?.classList.remove('d-none');
        document.querySelector('[data-selectYYM]')?.classList.add('d-none');
      }else{
        document.querySelector('[data-special-about]')?.classList.remove('d-none');
        document.querySelector('[data-seat-cover-feature]')?.classList.remove('d-none');
        document.querySelector('[data-index-reviews]')?.classList.remove('d-none');
        document.querySelectorAll('[data-features-content]').forEach( ele => ele.classList.remove('d-none'));
        document.querySelector('[data-selectYYM]')?.classList.remove('d-none')
      }

      document.querySelector('[data-features-content="quiz"]')?.classList.remove('d-none');

      //     let selectedPartNumber =   JSON.parse(localStorage.getItem('partNumbers'));
      // if(selectedPartNumber && isfiltered == 'true' &&){
      //   if(selectedPartNumber.length > 1 && selectedPartNumber ){
      //     document.querySelectorAll('.collection-product').forEach( ele => {
      //       ele.classList.add('d-none');
      //     });
      //     selectedPartNumber.forEach( part => {
      //       document.querySelector(`.collection-product[data-partNumber="${part}"]`)?.classList.remove('d-none');
      //     })
      //   } 
      // }
    }
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _finalQueryString(form) {

    const formData = new FormData(form);
    let searchParams = '';
    let constraints = '';
    formData.forEach((val, key) => {
      if (key.indexOf('price-list') >= 0) {
        searchParams += '&' + val;
      } else if (key.indexOf('custom_sort_by') >= 0) {
        //  Code for SortBy
      } else if (key.indexOf('tagsFilter-') > -1) {
        if (constraints === '') { constraints = val; }
        else { constraints += `+${val}`; }
      } else if (val != null && val.length > 0) {
        if (searchParams === '') { searchParams = key + '=' + val; }
        else { searchParams += '&' + key + '=' + val; }
      }
    });
    if (constraints != '') {
      if (searchParams == '') {
        searchParams = `?constraint=${constraints}`;
      } else {
        searchParams += `&constraint=${constraints}`;
      }
    }
    return searchParams;
  }

  /**
  * Update Window URL as per active filters
  * @param {event} event Event Instance
  */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {String} updateURLHash true/false
   */
  renderPage(searchParams, updateURLHash = true) {

    // document.getElementById('collection-product-grid').querySelector('#template-collection').classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination / sub_collection_filter
   */
  renderGridFromFetch(url, type) {
    if (!url) return;
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
         this.renderProductGrid(html, type);
      });
  }

  /**
   * 
   * @param {HTMlResponse} html 
   * @param {String} type filter / pagination / sub_collection_filter
   */
  async renderProductGrid(html, type) {

    const innerHTML = new DOMParser().parseFromString(html, 'text/html');
    const activeFilters = innerHTML.querySelector('[data-activeFilters]');
    if (activeFilters && document.querySelector('[data-activeFilters]')) document.querySelector('[data-activeFilters]').innerHTML = activeFilters.innerHTML;

    this._displaySelectedVehicle();

    document.querySelector('[ data-fixedFilter]') ? document.querySelector('[ data-fixedFilter]').classList.add('d-none') : '';
    var materialsToshow = [];

    innerHTML.querySelectorAll('[data-materialCollectionGrid] [data-collectionProducts]').forEach(ele => {
      //ele.classList.add('d-none');
      ele.getAttribute('data-productFabric') != '' ? materialsToshow.push(ele.getAttribute('data-productFabric')) : '';
    })

    if (document.querySelector('[data-enablegrids]')){
      document.querySelector('[data-enablegrids]')?.classList.remove('d-none')
      document.querySelector('[data-enablegrids]')?.classList.remove('disabled-grids')
    }

    //update selection
    document.querySelector('[data-selectYYM]')?.classList.add('d-none');
    document.querySelector('[data-selectedYYM]')?.classList.remove('d-none');

    // We have used individuals components replacement code because of load more feature
    let paginationType = 'numbers';
    if (document.querySelector('[data-pagination]')) {
      paginationType = document.querySelector('[data-pagination]').dataset.type || 'numbers';
    }
    if (type == 'filter' || type == 'sub_collection_filter') {
      const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
      document.getElementById('collection-product-grid').innerHTML = gridHTML;

      if (type == 'sub_collection_filter') {
        let bannerHTML = innerHTML.querySelector('[data-collectionBanner]').innerHTML;
        document.querySelector('[data-collectionBanner]').innerHTML = bannerHTML;
      }
    } else {
      if (paginationType == 'loadmore') {
        let productGrids = innerHTML.getElementById('template-collection').innerHTML;
        let loadMoreBtn = innerHTML.getElementById('load-more');
        document.getElementById('template-collection').insertAdjacentHTML('beforeend', productGrids);
        if (loadMoreBtn && document.getElementById('load-more')) {
          document.getElementById('load-more').parentNode.replaceChild(loadMoreBtn, document.getElementById('load-more'));
        }
        else if (document.getElementById('load-more')) { document.getElementById('load-more').remove(); }
      } else {
        const gridHTML = innerHTML.getElementById('collection-product-grid').innerHTML;
        document.getElementById('collection-product-grid').innerHTML = gridHTML;
      }
    }

    document.querySelector('[ data-special-about]')?.classList.add('d-none');
    document.querySelector('[data-seat-cover-feature]')?.classList.add('d-none');
    document.querySelector('[data-index-reviews]')?.classList.add('d-none');
    document.querySelectorAll('[data-features-content]').forEach( ele => ele.classList.add('d-none'));
    document.querySelector('[data-features-content="quiz"]')?.classList.remove('d-none');

    const totalProducts = innerHTML.querySelector('[data-totalProducts]');
    if (totalProducts) document.querySelector('[data-totalProducts]').innerHTML = totalProducts.innerHTML;

    if(selectedPartNumber.length < 1 && selected_year ){
      document.querySelector('.collection-grid-wrapper').innerHTML = `<h4 class="h5 text-center text-uppercase">No Products available</h4>`
    }

    let materials = [...new Set(materialsToshow)];

    document.querySelectorAll('[data-material]').forEach(ele => {
      ele.classList.add('d-none')
    })

    if(materials.length > 0 ){
      materials.forEach(material => {
         const materialLowerCase = material.toLowerCase();
         const elements = document.querySelectorAll(`[data-material="${materialLowerCase}"], [data-material="${material}"]`);
         elements.forEach(element => {
            element.classList.remove('d-none');
            element.querySelectorAll('[data-selectMatrialCTA]').forEach(btn => {
              btn.classList.add('d-none');
            });
            element.querySelectorAll('[data-shopMaterialProducts]').forEach(btn => {
              btn.classList.remove('d-none');
            });
          });
        // document.querySelectorAll(`[data-material="${materialLowerCase}"]`).forEach(element => {
        //   element.classList.remove('d-none')
        //   element.querySelectorAll('[data-selectMatrialCTA]').forEach(btn => {
        //     btn.classList.add('d-none');
        //   })
        //   element.querySelectorAll('[data-shopMaterialProducts]').forEach(btn => {
        //     btn.classList.remove('d-none');
        //   })
        // })
      })
      this._popluateMaterials(materials);
      this.sortProducts();
        document.querySelectorAll('[data-materialCollectionGrid] [data-collectionProducts]').forEach(ele => {
          //ele.classList.add('d-none');
        })
        document.querySelectorAll('.collection_material').forEach( ele => {
          ele.classList.add('d-none')
        })
    }
    else{
      document.querySelectorAll('.collection_material').forEach( ele => {
        ele.classList.add('d-none')
      })
      document.querySelectorAll('[data-materialCollectionGrid] [data-collectionProducts]').forEach(ele => {
        ele.classList.remove('d-none');
      })
    }

  }

   /**
     * sort the products based on the skus 
     */
   sortProducts(){
    try{
            var productContainer = document.querySelector('#template-collection');
            var products = Array.from(productContainer.querySelectorAll('.collection-product'));
            var sortedProducts = products.map(function(product) {
              var skuTag = product.dataset.sku;
              var matchResult = skuTag.match(/sku-([^\s]+)/);
              if (matchResult) {
                var alphanumericPart = matchResult[1];
                return { element: product, alphanumericPart: alphanumericPart };
              } else {
                return null;
              }
            });
            sortedProducts = sortedProducts.filter(function(item) {
              return item !== null;
            });
            sortedProducts.sort(function(a, b) {
              return a.alphanumericPart.localeCompare(b.alphanumericPart, undefined, { numeric: true });
            });
            sortedProducts.forEach(function(item) {
              productContainer.appendChild(item.element);
            });
    }
    catch(e){
        console.log(e)
    }
  }
  
  
  /**
   * populate the materials based on selection
   */
  _popluateMaterials() {
    this.sortProducts();
    document.querySelectorAll('[data-shopmaterialproducts]').forEach(element => {
      element.addEventListener('click', (event) => {
        let selectedMaterial = event.target.getAttribute('data-shopmaterial');
        let selectedMaterialCount = document.querySelectorAll(`[data-productFabric="${selectedMaterial}"]`).length;
        let identifyCollection = document.querySelector('[data-grid-collection]').getAttribute('data-grid-collection');

        if (selectedMaterialCount > 1 ) {
            document.querySelector('[data-collectionExtrainfo]')?.classList.add('d-none');
            selectedPartNumber.forEach( part => {
              if(identifyCollection == 'side-by-side-seat-covers'){
                part = part.toLowerCase();
              }
              document.querySelectorAll(`[data-productFabric="${selectedMaterial}"][data-partNumber="${part}"]`).forEach(ele => {
                ele.classList.remove('d-none');
              })
            })
          }
          document.querySelectorAll('[data-material]').forEach(element => {
            element.classList.add('d-none');
          })
        if (selectedMaterialCount == 1) {
          document.querySelector('[data-collectionExtrainfo]')?.classList.add('d-none');
          let productHandle = document.querySelector(`[data-productFabric="${selectedMaterial}"]`).getAttribute('data-productHandle');
          window.location = `/products/${productHandle}`
        }
      })
    })
  }


  /**
   * Update the url
   * @param {String} searchParams 
   */
  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  /**
   * 
   * @param {event} event 
   */
  updateSortBy(event) {
    let _this = event.currentTarget;
    // let currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_mobile"]:checked').value;

    let currentvalue;
    if (_this.name == 'custom_sort_by_desktop') {
      currentvalue = document.querySelector('[data-sortby] [name="custom_sort_by_desktop"]:checked').value;
    }

    document.querySelector('[name="custom_sort_by_desktop"]').value = currentvalue;
    document.querySelector('[name="sort_by"]').dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));

    let closestForm = document.getElementById('CollectionFiltersForm');
    closestForm.querySelector('[name="sort_by"]').value = currentvalue;


  }

  /**
   * 
   * @param {event} event 
   */
  updatePagination(event) {
    event.preventDefault();
    let _this = event.currentTarget;
    let currentvalue = document.querySelector('[data-custom-pagination] [type="radio"]:checked').value;

    this.querySelector('[name="count"]').value = currentvalue;
    this.querySelector('[name="count"]').dispatchEvent(new Event('input', {
      bubbles: true,
      cancelable: true,
    }));

  }

  /**
   * 
   * @param {event} event 
   */
  _managePagination(event) {
    event.preventDefault();
    let _this = event.currentTarget;
    var nextPageLink = _this.href;
    var product_count = parseInt(event.target.closest('[data-pagination_bar]')?.getAttribute('data-pagination_bar'))
    if (nextPageLink && nextPageLink.includes('?') && nextPageLink.includes('=')) {
      nextPageLink = nextPageLink + `&count=${product_count}`
    }
    this.renderGridFromFetch(nextPageLink, 'pagination');
    setTimeout(() => {
      history.pushState({}, '', nextPageLink);
    }, 500);
  }

}
customElements.define('collection-filters', CollectionFilters);

class CollectionFiltersVehicle extends CollectionFilters {

  constructor() {
    super();
    this.initJsonData();
  }

  async initJsonData(){
    let json = await vehicleUtility.tsvVehicleJSON();
    this.initVehicle(json);
    vehicleJson = json;
  }

  initVehicle(json){
    this.vehicleJsonData = json;
    this.defaultMaterial = window.globalVariables.default_material;

    this.uniqueYears = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.year)),
    ];
    this.uniqueMake = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.make))
    ];
    this.uniqueModels = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.model)),
    ];
    this.uniqueTrims = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.trim)),
    ];
    this.uniqueCabTypes = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.cab_type)),
    ];
    this.uniqueRows = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.row))
    ];

    document.querySelectorAll("[data-year-filter]") ? this.yearSelect = document.querySelectorAll("[data-year-filter]") : '';
    document.querySelectorAll("[data-make-filter]") ?  this.makeSelect = document.querySelectorAll("[data-make-filter]") : '';
    document.querySelectorAll("[data-model-filter]") ? this.modelSelect = document.querySelectorAll("[data-model-filter]"): '';
    document.querySelectorAll("[data-trim-filter]") ? this.trimSelect = document.querySelectorAll("[data-trim-filter]") : '';
    document.querySelectorAll("[data-cab-type-filter]") ?  this.cabTypeSelect = document.querySelectorAll("[data-cab-type-filter]") : '';
    document.querySelectorAll("[data-row-filter]") ?  this.rowSelect = document.querySelectorAll("[data-row-filter]") : '';
    document.querySelectorAll("[data-part-number-filter]") ?  this.partSelect = document.querySelectorAll("[data-part-number-filter]") : '';

    let yearHTML = '';
    this.uniqueYears.sort().reverse().forEach((years , index) => {
      
      if(years != null){
        yearHTML += `
        <li class="for-check filter__item" data-value="${years}">

        <div class="form-check">
        <label
        for="Filter-year-${index+1}"
        class="form-check-label option-label filter-checkbox"
        title="year"
        >
        <input
        type="radio"
        class="form-check-input m-0 d-none"
        data-value="${years}"
        value="${years}"
        id="Filter-year-${index+1}"
        data-year
        data-label="${years}"
        data-inputModel="false"
        >
        ${years}
        </label>
        </div>
        </li>
        `;
      }

      if (this.yearSelect != null) {
        this.yearSelect.forEach( ele => {
          ele.innerHTML = yearHTML
        })
      }
    });

    this._handleInputEvent();

  }

/**
 * Input events
 * 
 */
  _handleInputEvent() {
    let modelInputEle = document.querySelectorAll('[data-inputModel]');
    modelInputEle.forEach((ele, index) => {
      ele.addEventListener('click', event => {
        if(ele.hasAttribute('data-year')){
          let currentvalue = ele.getAttribute('data-label');
          selected_year = currentvalue;
          selected_make='' , selected_model='' , selected_trim='' , selected_cab='';
          this.makeSelect.forEach( ele => {
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.classList.add('disabled')
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Make';
          })
          this.modelSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })
          this.trimSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })
          this.cabTypeSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })

          this._updateMake(currentvalue);
          this.yearSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })

        }
        else if(ele.hasAttribute('data-make')){
          let currentvalue = ele.getAttribute('data-label');
          selected_make = currentvalue;
          selected_model='' , selected_trim='' , selected_cab='';
         
          this.modelSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Model';

          })
          this.trimSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })
          this.cabTypeSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.add('disabled');
          }) 
          this._updateModel(currentvalue);
          this.makeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-model')){
          let _this = event.currentTarget; 
          let currentvalue = ele.getAttribute('data-label');
          selected_model = currentvalue;
          selected_trim='' , selected_cab='';
          this.trimSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Trim';
          })
          this.cabTypeSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.add('disabled');
          }) 
          this._updateTrim(selected_year , selected_make , selected_model);
          this._updateRow(selected_year , selected_make , selected_model , selected_trim , selected_cab);
          this._updateParts(selected_year , selected_make , selected_model , selected_trim , selected_cab);
          this.modelSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-trim')){
          let _this = event.currentTarget; 
          let currentvalue = ele.getAttribute('data-label');
          selected_trim = currentvalue;
          selected_cab='';
          this.cabTypeSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })
          this._updateCabType(selected_year , selected_make , selected_model , selected_trim);
          this._updateRow(selected_year , selected_make , selected_model , selected_trim , selected_cab);
          this._updateParts(selected_year , selected_make , selected_model , selected_trim , selected_cab);
          this.trimSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-cab-type')){
          let _this = event.currentTarget; 
          let currentvalue = ele.getAttribute('data-label');
          selected_cab = currentvalue;
          this.cabTypeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          this._updateRow(selected_year , selected_make , selected_model, selected_trim , selected_cab );
          this._updateParts(selected_year , selected_make , selected_model , selected_trim , selected_cab);
        }
       

        let dataFilter = event.target.closest('[data-filter]').dataset.filter;
        let parents = document.querySelectorAll(`[data-filter="${dataFilter}"]`);
        let formElement = document.querySelector("[data-fixedfilter] #CollectionFiltersForm");

        if (dataFilter && formElement) {
          let elementName = ele.getAttribute("name");
          let existingInputElement = formElement.querySelector(`input[type="hidden"][name="${elementName}"]`);

          if (existingInputElement) {
            let eleVal = ele.getAttribute('data-label');
            existingInputElement.value = eleVal;
          } else {
            let inputElementHTML = `<input type="hidden" name="${elementName}" value="${ele.value}">`;
            formElement.insertAdjacentHTML('afterbegin', inputElementHTML);
          }

          parents.forEach((parent, index) => {
            let selectedValues = parent.querySelectorAll('[data-selctedInputValue]');
            selectedValues.forEach((selectedValue, index) => {
              let elVal = ele.getAttribute('data-label');
              selectedValue.innerHTML = elVal;
            });
          });
        }
      })
    })
  }


  /**
   * 
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   * @param {*} trim - selected trim
   * @param {*} cab_type - selected cab type
   */
  _updateParts( year , make , model , trim , cab_type ){
    let selectedYear = year;
    let selectedMake = make;
    let selectedModel = model;
    let selectedTrim = trim ;
    let selectedCabType = cab_type;

    let rowEls = this.querySelectorAll('[data-row-filter] li');
    let uniquePartNumbers = [];
    if (rowEls.length > 0) {
        rowEls.forEach((row) => {
            let rowValue = row.getAttribute('data-value');
            let filteredParts;

            if (selectedTrim == '' && selectedCabType == '') {
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            } else if(selectedTrim != '' && selectedCabType == ''){
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.trim === selectedTrim &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            } else {
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.trim === selectedTrim &&
                                    item.cab_type === selectedCabType &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            }

            // Add the unique part numbers to the result array
            uniquePartNumbers.push(...filteredParts);
        });
    }
    else{
        let filteredParts;
  
        if (selectedTrim == '' && selectedCabType == '') {
          filteredParts = [
              ...new Set(
                  Object.values(this.vehicleJsonData)
                      .filter(
                          (item) =>
                              item.year === selectedYear &&
                              item.make === selectedMake &&
                              item.model === selectedModel 
                      )
                      .map((item) => item.part_number)
              ),
          ];
      } else if(selectedTrim != '' && selectedCabType == ''){
        filteredParts = [
            ...new Set(
                Object.values(this.vehicleJsonData)
                    .filter(
                        (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel &&
                            item.trim === selectedTrim 
                    )
                    .map((item) => item.part_number)
            ),
        ];
      } else {
          filteredParts = [
              ...new Set(
                  Object.values(this.vehicleJsonData)
                      .filter(
                          (item) =>
                              item.year === selectedYear &&
                              item.make === selectedMake &&
                              item.model === selectedModel &&
                              item.trim === selectedTrim &&
                              item.cab_type === selectedCabType 
                      )
                      .map((item) => item.part_number)
              ),
          ];
      }
  
      // Add the unique part numbers to the result array
      uniquePartNumbers.push(...filteredParts);
      }

    // Remove duplicates from the result array
    uniquePartNumbers = [...new Set(uniquePartNumbers)];
    selectedPartNumber = uniquePartNumbers;
    localStorage.setItem('partNumbers', JSON.stringify(uniquePartNumbers));

    let optionHTML = "";

    if(uniquePartNumbers.length > 0){
      uniquePartNumbers.sort().forEach((option) => {
        if (option !== null) {
          var prefixedParts = selectedPartNumber.map(function(element) {
            return "sku-" + element.toUpperCase();
        });
        var partsNumber = prefixedParts.join(",");
          optionHTML += `
          <li class="for-check" data-value="${option}">
              <input type="checkbox" class="ymm-input form-check-input d-none" data-label="${option}" value="sku-${option}" data-value="${option}" id="year-${option}" name="filter.p.tag" checked/>
              <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
          </li>`;
        } 
      });
    }
    
    this.partSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

}


/**
 * 
 * Update the rows
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   * @param {*} trim - selected trim
   * @param {*} cab_type - selected cab type
 */
  _updateRow( year , make , model , trim , cab_type){

let selectedYear = year;
let selectedMake = make;
let selectedModel = model;
let selectedTrim = trim ;
let selectedCabType = cab_type;

    let filteredRows;
    if(selectedTrim == '' && selectedCabType == ''){
        filteredRows =
            selectedModel !== ""
            ? [
                ...new Set(
                    Object.values(this.vehicleJsonData)
                    .filter(
                        (item) =>
                        item.year === selectedYear &&
                        item.make === selectedMake &&
                        item.model === selectedModel 
                    )
                    .map((item) => item.row)
                ),
                ]
            : this.uniqueRows;
    } else {
        filteredRows =
            selectedCabType !== ""
            ? [
                ...new Set(
                    Object.values(this.vehicleJsonData)
                    .filter(
                        (item) =>
                        item.year === selectedYear &&
                        item.make === selectedMake &&
                        item.model === selectedModel &&
                        item.trim === selectedTrim &&
                        item.cab_type === selectedCabType
                    )
                    .map((item) => item.row)
                ),
                ]
            : this.uniqueRows;
    }


    let optionHTML = "";

    filteredRows.sort().forEach((option) => {
      if (option !== null) {
        optionHTML += `
        <li class="for-check" data-value="${option}">
            <input type="radio" class="ymm-input form-check-input d-none" data-label="${option}" value="${option}" data-value="${option}" id="year-${option}" name="filter.p.m.fit.row"/>
            <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
        </li>`;
       
      } 
    });
   
    this.rowSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

  }



/**
 * 
 * @param {*} year - year
 * @param {*} make - make
 * @param {*} model - model
 * @param {*} trim - trim
 */
 _updateCabType( year , make , model , trim) {

    const filteredCabTypes =
      selected_trim !== ""
        ? [
            ...new Set(
              Object.values(this.vehicleJsonData)
                .filter(
                  (item) =>
                    item.year === year &&
                    item.make === make &&
                    item.model === model &&
                    item.trim === trim
                )
                .map((item) => item.cab_type)
            ),
          ]
        : uniqueCabTypes;
   
  let optionHTML ="";
  filteredCabTypes.sort().forEach((option , index) => {
    if (option !== null) {
        optionHTML += `
          <li class="filter__item">
          <div class="form-check">
          <label for="Filter-cab-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
          <input type="radio" class="form-check-input m-0 d-none"
          data-value="${option}" value="${option}"  data-label="${option}" id="Filter-cab-${index+1}" data-handle="${option}" data-cab-type=""
          data-inputmodel="false">
          ${option}
          </label>
          </div>
          </li>
      `;
    }
    else{
      document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
        ele.classList.remove('disabled')
      })
    }
  });

  if(!filteredCabTypes.includes(null)){
    this.cabTypeSelect.forEach( ele => {
      ele.closest('.custom-dropdown').classList.remove('disabled');
      ele.innerHTML = optionHTML
    })
  }
  this._handleInputEvent();
}

  /**
 * update the models
 */
  _updateModel(){
   let selectedYear = selected_year;
    let selectedMake = selected_make;
    const filteredModels =
      selectedMake !== ""
        ? [
            ...new Set(
              Object.values(this.vehicleJsonData)
                .filter(
                  (item) =>
                    item.year === selectedYear && item.make === selectedMake
                )
                .map((item) => item.model)
            ),
          ]
        : this.uniqueModels;


    let modeloptionHTML ="";
    filteredModels.sort().forEach((option , index) => {
      if (option != null) {
        let optionVal = Utility._createSlug(option);
        modeloptionHTML += `
            <li class="filter__item">
            <div class="form-check">
            <label for="Filter-model-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
            <input type="radio" class="form-check-input m-0 d-none" 
            data-value="${option}" data-label="${option}" value="${option}" id="Filter-model-${index+1}" data-handle="${option}" data-model=""
            data-inputmodel="true">
            ${option}
            </label>
            </div>
            </li>
        `;
      }
    });
    
    this.modelSelect.forEach( ele => {
      ele.closest('.custom-dropdown').classList.remove('disabled');
      ele.innerHTML = modeloptionHTML;
    })
    this._handleInputEvent();
  }

  /**
   * 
   * @param {*} inputValue - selected year value
   * update the make
   */
  _updateMake(inputValue){
    const selectedYear = inputValue;

    // Filter available options based on user selections
    const filteredMakes = this.uniqueYears.includes(selectedYear)
        ? [
            ...new Set(
            Object.values(this.vehicleJsonData)
                .filter((item) => item.year === selectedYear)
                .map((item) => item.make)
            ),
        ]
        : uniqueYears;
   
        let optionHTML ="";
        filteredMakes.sort().forEach((option , index) => {
          if (option !== null) {
            let optionVal = Utility._createSlug(option)
              optionHTML += `
                <li class="filter__item">
                <div class="form-check">
                <label for="Filter-Make-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
                <input type="radio" class="form-check-input m-0 d-none"
                data-value="${option}" data-label="${option}" value="${option}" id="Filter-Make-${index+1}" data-handle="${option}" data-make=""
                data-inputmodel="false">
                ${option}
                </label>
                </div>
                </li>
            `;
          }
        });
        
        this.makeSelect.forEach( ele => {
          ele.closest('.custom-dropdown').classList.remove('disabled');
          ele.innerHTML = optionHTML;
        })
        
        this._handleInputEvent();
  }

  /**
   * 
   * @param {*} year - selected year
   * @param {*} make  - selected make
   * @param {*} model - selcted model
   * update the trim
   */
  _updateTrim(year, make, model) {
    let selectedYear = year;
    let selectedMake = make;
    let selectedModel = model;
    let vehicleJsonData = vehicleJson;

    const filteredTrims =
      selectedModel !== ""
        ? [
          ...new Set(
            Object.values(this.vehicleJsonData)
              .filter(
                (item) =>
                  item.year === selectedYear &&
                  item.make === selectedMake &&
                  item.model === selectedModel
              )
              .map((item) => item.trim)
          ),
        ]
        : uniqueTrims;
        this._handleInputEvent();
    if (filteredTrims.length > 1 && filteredTrims != null) {
      document.querySelectorAll('[data-filter="trim"],[data-filter="cab-type"]').forEach(ele => {
        ele.classList.remove('d-none');
      })
      let optionHTML ="";
      filteredTrims.sort().forEach((option , index) => {
        if (option !== null) {
          let optionVal = Utility._createSlug(option)
            optionHTML += `
              <li class="filter__item">
              <div class="form-check">
              <label for="Filter-Trim-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
              <input type="radio" class="form-check-input m-0 d-none" 
              data-value="${option}" value="${option}" data-label="${option}" id="Filter-Trim-${index+1}" data-handle="${option}" data-trim=""
              data-inputmodel="false">
              ${option}
              </label>
              </div>
              </li>
          `;
        }
      });
      this.trimSelect.forEach( ele => {
       ele.closest('.custom-dropdown').classList.remove('disabled');
       ele.innerHTML = optionHTML;
      })
    }
    else {
      document.querySelectorAll('[data-filter="trim"] , [data-filter="cab-type"]').forEach(ele => {
        ele.classList.add('d-none');
      })
      document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
        ele.classList.remove('disabled')
      })
    }

  this._handleInputEvent();
  }
}
customElements.define('collection-filters-vehicle', CollectionFiltersVehicle);

class CollectionHeavyEquipment extends CollectionFilters {

  constructor() {
    super();
    this.tsvheavyEqJSON();
  }

  async tsvheavyEqJSON(){
    let json = await vehicleUtility.tsvheavyEqJSON();
    this.initHeavyEq(json);
  }


  initHeavyEq(json){
  this.heavyEquipmentJsonData =  json;

  this.uniqueCategory = [
      ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_category.trim()))
  ];
  this.uniqueManufacture = [
      ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_manufacturer)),
  ];
  this.uniqueModelNumber = [
      ...new Set(Object.values(this.heavyEquipmentJsonData).map((item) => item.equipment_model_number)),
  ];

  this.typeSelect = document.querySelectorAll("[data-equipment-type-filter]");
  this.manufacturerSelect = document.querySelectorAll("[data-manufacturer-filter]");
  this.modelNumberSelect = document.querySelectorAll("[data-model-number-filter]");
  this.eqPartSelect = document.querySelectorAll('[data-equipment-part-filter-select]');

  let equipTypeHTML =''
  this.uniqueCategory.sort().forEach((category , index) => {
    if(category != null){
      let categoryVal = Utility._createSlug(category);
      equipTypeHTML += `
      <li class=" my-2  filter__item">
      <div class="form-check">
        <label for="Filter-Equipment-Type-${index}" class="form-check-label option-label filter-checkbox" title="${category}">
          <input type="radio" class="form-check-input m-0 d-none" data-label="${category}" data-value="${category}" value="${category}" id="Filter-Equipment-Type-${index}" data-handle="${category}" data-equipment-type data-inputmodel="false">
          ${category}
        </label>
      </div>
    </li>
      `;
    }
  });

  this.typeSelect.forEach( ele => {
  ele.innerHTML = equipTypeHTML
  })

  this._handleInputEvent();

  this.typeSelect.forEach( ele => {
  this.typeInputs = ele.querySelectorAll('input');
  this.typeInputs.forEach((typeInput) => {
    typeInput.addEventListener('change', (event) => {
        this._updateManufacture(selected_equipemnt_type);
    })
  })

  });
  }

  _handleInputEvent(){
    let modelInputEle = document.querySelectorAll('[data-inputModel]');
    modelInputEle.forEach((ele, index) => {
      ele.addEventListener('change', event => {

        if(ele.hasAttribute('data-equipment-type')){
          let currentvalue = ele.getAttribute('data-label');
          let currentvalueLabel = ele.getAttribute('data-label');
          selected_equipemnt_type = currentvalueLabel;
          this.typeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-equipment-manufacturer')){
          let currentvalue = ele.value;
          let currentvalueLabel = ele.getAttribute('data-label');
          selected_eq_manufacturer = currentvalueLabel;
          this._updateEqModel(currentvalueLabel);
          this.manufacturerSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-model-number')){
          let _this = event.currentTarget;
          let currentvalue = ele.value;
          let currentvalueLabel = ele.getAttribute('data-label');
          selected_eq_model = currentvalueLabel;
          this._updateParts();
          this.modelNumberSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled')
          })
        }


        let dataFilter = event.target.closest('[data-filter]').dataset.filter;
        let parents = document.querySelectorAll(`[data-filter="${dataFilter}"]`);
        let formElement = document.querySelector("[data-fixedfilter] #CollectionFiltersForm");

        if (dataFilter && formElement) {
          let elementName = ele.getAttribute("name");
          let existingInputElement = formElement.querySelector(`input[type="hidden"][name="${elementName}"]`);

          if (existingInputElement) {
            let eleVal = ele.getAttribute('data-label');
            existingInputElement.value = eleVal;
          } else {
            let inputElementHTML = `<input type="hidden" name="${elementName}" value="${ele.value}">`;
            formElement.insertAdjacentHTML('afterbegin', inputElementHTML);
          }

          parents.forEach((parent, index) => {
            let selectedValues = parent.querySelectorAll('[data-selctedInputValue]');
            selectedValues.forEach((selectedValue, index) => {
              let elVal = ele.getAttribute('data-label');
              selectedValue.innerHTML = elVal;
            });
          });
        }
      })
    })
  }

/**
 * 
 * @param {*} inputValue - selected equipment type
 */
_updateManufacture(inputValue){
  let selectedCategory = inputValue;
  // Filter available options based on user selections
  const filteredManufacturer = this.uniqueCategory.includes(selectedCategory)
      ? [
          ...new Set(
          Object.values(this.heavyEquipmentJsonData)
              .filter((item) => item.equipment_category.trim() === selectedCategory)
              .map((item) => item.equipment_manufacturer)
          ),
      ]
      : this.uniqueCategory;
  
      let equipManufacturerHTML="";
      this.manufacturerSelect.forEach( ele => {
        ele.innerHTML = '';
      })
      filteredManufacturer.sort().forEach((manufacturer,index) => {
        if(manufacturer != null ){
          let manufactureVal = Utility._createSlug(manufacturer);
            equipManufacturerHTML += `
            <li class=" my-2  filter__item">
            <div class="form-check">
              <label for="Filter-Manufacturer-${index}" class="form-check-label option-label filter-checkbox" title="${manufacturer}">
                <input type="radio" class="form-check-input m-0 d-none" data-label="${manufacturer}" data-value="${manufacturer}" value="${manufacturer}" id="Filter-Manufacturer-${index}" data-handle="${manufacturer}" data-equipment-manufacturer data-inputmodel="false">
                ${manufacturer}
              </label>
            </div>
          </li>
            `;
        }
      });

      this.manufacturerSelect.forEach( ele => {
        ele.closest('.custom-dropdown').classList.remove('disabled')
        ele.innerHTML = equipManufacturerHTML ;
      })
    
      this._handleInputEvent(); 
}
/**
 * 
 * @param {]} inputValue - model value
 */
  _updateEqModel(inputValue){
    let selectedManufacturer = inputValue;
    let filteredModel;
    // Filter available options based on user selections

    if(document.querySelectorAll('[name="filter.p.m.custom.product_equipment_type"]:checked')){
      let selectedCategory = document.querySelector('input[data-equipment-type]:checked').getAttribute('data-label');
       // Filter available options based on user selections
          filteredModel = this.uniqueManufacture.includes(selectedManufacturer)
          ? [
              ...new Set(
              Object.values(this.heavyEquipmentJsonData)
                  .filter((item) => item.equipment_manufacturer === selectedManufacturer && item.equipment_category.trim() === selectedCategory)
                  .map((item) => item.equipment_model_number)
              ),
          ]
          : this.uniqueManufacture;
      // Populate the selects with filtered options
  } else {
      // Filter available options based on user selections
      filteredModel = this.uniqueManufacture.includes(selectedManufacturer)
      ? [
          ...new Set(
          Object.values(this.heavyEquipmentJsonData)
              .filter((item) => item.equipment_manufacturer === selectedManufacturer)
              .map((item) => item.equipment_model_number)
          ),
      ]
      : this.uniqueManufacture;
      // Populate the selects with filtered options
  }
    this.modelNumberSelect.innerHTML = "";
    let optionHTML = "";
    filteredModel.sort().forEach((option,index) => {
      if (option != null) {

        let optionVal = Utility._createSlug(option)

        optionHTML += `
        <li class=" my-2  filter__item">
        <div class="form-check">
          <label for="Filter-Eqmodel-${index}" class="form-check-label option-label filter-checkbox" title="${option}">
            <input type="radio" class="form-check-input m-0 d-none" data-label="${option}" data-value="${option}" value="${option}" id="Filter-Eqmodel-${index}" data-handle="${option}" data-model-number data-inputmodel="false">
            ${option}
          </label>
        </div>
      </li>
        `;
        this.modelNumberSelect.forEach( ele => {
          ele.closest('.custom-dropdown').classList.remove('disabled')
        })
      }
    });
 
    this.modelNumberSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
     })
    this._handleInputEvent();

}

/**
 * 
 */
_updateParts(){
  let filteredParts;
  let uniquePartNumbers = [];

      // Filter available options based on user selections
      filteredParts = [
          ...new Set(
              Object.values(this.heavyEquipmentJsonData)
                  .filter(
                      (item) =>
                          item.equipment_manufacturer == selected_eq_manufacturer &&
                          item.equipment_category == selected_equipemnt_type &&
                          item.equipment_model_number == selected_eq_model
                  )
                  .map((item) => item.equipment_part_number)
          ),
      ];

      uniquePartNumbers.push(...filteredParts);

       // Remove duplicates from the result array
    uniquePartNumbers = [...new Set(uniquePartNumbers)];
    selectedPartNumber = uniquePartNumbers;

    let optionHTML = "";

    if(uniquePartNumbers.length > 0){
      uniquePartNumbers.sort().forEach((option) => {
        if (option !== null) {
          var prefixedParts = selectedPartNumber.map(function(element) {
            return "sku-" + element.toUpperCase();
        });
        var partsNumber = prefixedParts.join(",");
          optionHTML += `
          <li class="for-check" data-value="${option}">
              <input type="checkbox" class="ymm-input form-check-input d-none" data-label="${option}" value="sku-${option}" data-value="${option}" id="year-${option}" name="filter.p.tag" checked/>
              <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
          </li>`;
        } 
      });
    }

    this.eqPartSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

}

}
customElements.define('collection-filters-heavy-euipment', CollectionHeavyEquipment);

class CollectionFiltersSide extends CollectionFilters {

  constructor() {
    super();
    this.initJsonData();
  }

  async initJsonData(){
    let json = await vehicleUtility.tsvsideJSON();
    this.initVehicle(json);
    vehicleJson = json;
  }

  initVehicle(json){
    this.vehicleJsonData = json;
    this.defaultMaterial = window.globalVariables.default_material;

    this.uniqueYears = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.year)),
    ];
    this.uniqueMake = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.make))
    ];
    this.uniqueModels = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.model)),
    ];
    this.uniqueRows = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.row))
  ];

    document.querySelectorAll("[data-side-year-filter]") ? this.yearSelect = document.querySelectorAll("[data-side-year-filter]") : '';
    document.querySelectorAll("[data-side-make-filter]") ?  this.makeSelect = document.querySelectorAll("[data-side-make-filter]") : '';
    document.querySelectorAll("[data-side-model-filter]") ? this.modelSelect = document.querySelectorAll("[data-side-model-filter]"): '';
    document.querySelectorAll("[data-side-part-filter]") ? this.partSelect = document.querySelectorAll("[data-side-part-filter]"): '';
    document.querySelectorAll("[data-side-row-filter]") ? this.rowSelect = document.querySelectorAll("[data-side-row-filter]"): '';

    let yearHTML = '';
    this.uniqueYears.sort().reverse().forEach((years , index) => {
      
      if(years != null){
        yearHTML += `
        <li class="for-check filter__item" data-value="${years}">
        <div class="form-check">
        <label
        for="Filter-year-side-${index+1}"
        class="form-check-label option-label filter-checkbox"
        title="year"
        >
        <input
        type="radio"
        class="form-check-input m-0 d-none"
        data-value="${years}"
        value="${years}"
        id="Filter-year-side-${index+1}"
        data-side-year
        data-label="${years}"
        data-inputSideModel="false"
        >
        ${years}
        </label>
        </div>
        </li>
        `;
      }

      if (this.yearSelect != null) {
        this.yearSelect.forEach( ele => {
          ele.innerHTML = yearHTML
        })
      }
    });

    this._handleInputEvent();
  }

/**
 * Input events
 * 
 */
  _handleInputEvent() {
    let modelInputEle = document.querySelectorAll('[data-inputSideModel]');
    modelInputEle.forEach((ele, index) => {
      ele.addEventListener('click', event => {

        if(ele.hasAttribute('data-side-year')){
          let currentvalue = ele.getAttribute('data-label');
          selected_year = currentvalue;
          selected_make='' , selected_model='' 

          this.makeSelect.forEach( ele => {
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.classList.add('disabled');
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Make';
          })
          this.modelSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })

          this._updateMake(currentvalue);
          this.yearSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })

        }
        else if(ele.hasAttribute('data-make')){
          let currentvalue = ele.getAttribute('data-label');
          selected_make = currentvalue;
          selected_model=''
         
          this.modelSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Model';

          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.add('disabled');
          }) 
          this._updateModel(currentvalue);
          this.makeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-model')){
          let _this = event.currentTarget; 
          let currentvalue = ele.getAttribute('data-label');
          selected_model = currentvalue;
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          this._updateRow(selected_year , selected_make , selected_model);
          this._updateParts(selected_year , selected_make , selected_model);
          this.modelSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }

        let dataFilter = event.target.closest('[data-filter]').dataset.filter;
        let parents = document.querySelectorAll(`[data-filter="${dataFilter}"]`);
        let formElement = document.querySelector("[data-fixedfilter] #CollectionFiltersForm");

        if (dataFilter && formElement) {
          let elementName = ele.getAttribute("name");
          let existingInputElement = formElement.querySelector(`input[type="hidden"][name="${elementName}"]`);

          if (existingInputElement) {
            let eleVal = ele.getAttribute('data-label');
            existingInputElement.value = eleVal;
          } else {
            let inputElementHTML = `<input type="hidden" name="${elementName}" value="${ele.value}">`;
            formElement.insertAdjacentHTML('afterbegin', inputElementHTML);
          }

          parents.forEach((parent, index) => {
            let selectedValues = parent.querySelectorAll('[data-selctedInputValue]');
            selectedValues.forEach((selectedValue, index) => {
              let elVal = ele.getAttribute('data-label');
              selectedValue.innerHTML = elVal;
            });
          });
        }
      })
    })
  }


  /**
 * 
 * Update the rows
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   * @param {*} trim - selected trim
   * @param {*} cab_type - selected cab type
 */
  _updateRow( year , make , model , trim , cab_type){

    let selectedYear = year;
    let selectedMake = make;
    let selectedModel = model;
    
        let filteredRows;
       filteredRows =
                selectedModel !== ""
                ? [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                        .filter(
                            (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel 
                        )
                        .map((item) => item.row)
                    ),
                    ]
                : this.uniqueRows;
    
        let optionHTML = "";
    
        filteredRows.sort().forEach((option) => {
          if (option !== null) {
            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="ymm-input form-check-input d-none" data-label="${option}" value="${option}" data-value="${option}" id="year-side-${option}"/>
                <label class="option_txt form-check-label w-100 text-capitalize" for="year-side-${option}" title="Label for ${option}">${option}</label>
            </li>`;
          } 
        });
       
        this.rowSelect.forEach( ele => {
          ele.innerHTML = optionHTML;
        })
      }


  /**
   * 
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   */
  _updateParts( year , make , model ){
    let selectedYear = year;
    let selectedMake = make;
    let selectedModel = model;
    let uniquePartNumbers = [];
 
        let filteredParts;
  
        filteredParts = [
          ...new Set(
              Object.values(this.vehicleJsonData)
                  .filter(
                      (item) =>
                          item.year === selectedYear &&
                          item.make === selectedMake &&
                          item.model === selectedModel 
                  )
                  .map((item) => item.part_number)
          ),
      ];
  
      // Add the unique part numbers to the result array
      uniquePartNumbers.push(...filteredParts);

    // Remove duplicates from the result array
    uniquePartNumbers = [...new Set(uniquePartNumbers)];
    selectedPartNumber = uniquePartNumbers;
    localStorage.setItem('partNumbers', JSON.stringify(uniquePartNumbers));

    let optionHTML = "";

    if(uniquePartNumbers.length > 0){
      uniquePartNumbers.sort().forEach((option) => {
        if (option !== null) {
         
          var prefixedParts = selectedPartNumber.map(function(element) {
            return "sku-" + element.toUpperCase();
        });
        var partsNumber = prefixedParts.join(",");
        let partNum = option;
          optionHTML += `
          <li class="for-check" data-value="${option}">
              <input type="checkbox" class="ymm-input form-check-input d-none" data-label="${option}" value="sku-${partNum}" data-value="${option}" id="year-${option}" name="filter.p.tag" checked/>
              <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
          </li>`;
        } 
      });
    }
   
    this.partSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

}

  /**
 * update the models
 */
  _updateModel(){
   let selectedYear = selected_year;
    let selectedMake = selected_make;
    const filteredModels =
      selectedMake !== ""
        ? [
            ...new Set(
              Object.values(this.vehicleJsonData)
                .filter(
                  (item) =>
                    item.year === selectedYear && item.make === selectedMake
                )
                .map((item) => item.model)
            ),
          ]
        : this.uniqueModels;


    let modeloptionHTML ="";
    filteredModels.sort().forEach((option , index) => {
      if (option != null) {
        let optionVal = Utility._createSlug(option);
        modeloptionHTML += `
            <li class="filter__item">
            <div class="form-check">
            <label for="Filter-model-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
            <input type="radio" class="form-check-input m-0 d-none" 
            data-value="${option}" data-label="${option}" value="${option}" id="Filter-model-${index+1}" data-handle="${option}" data-model=""
            data-inputSideModel="true">
            ${option}
            </label>
            </div>
            </li>
        `;
      }
    });
    
    this.modelSelect.forEach( ele => {
      ele.closest('.custom-dropdown').classList.remove('disabled');
      ele.innerHTML = modeloptionHTML;
    })
    this._handleInputEvent();
  }

  /**
   * 
   * @param {*} inputValue - selected year value
   * update the make
   */
  _updateMake(inputValue){
    const selectedYear = inputValue;

    // Filter available options based on user selections
    const filteredMakes = this.uniqueYears.includes(selectedYear)
        ? [
            ...new Set(
            Object.values(this.vehicleJsonData)
                .filter((item) => item.year === selectedYear)
                .map((item) => item.make)
            ),
        ]
        : uniqueYears;
   
        let optionHTML ="";
        filteredMakes.sort().forEach((option , index) => {
          if (option !== null) {
            let optionVal = Utility._createSlug(option)
              optionHTML += `
                <li class="filter__item">
                <div class="form-check">
                <label for="Filter-Make-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
                <input type="radio" class="form-check-input m-0 d-none"
                data-value="${option}" data-label="${option}" value="${option}" id="Filter-Make-${index+1}" data-handle="${option}" data-make=""
                data-inputSideModel="false">
                ${option}
                </label>
                </div>
                </li>
            `;
          }
        });
        
        this.makeSelect.forEach( ele => {
          ele.closest('.custom-dropdown').classList.remove('disabled');
          ele.innerHTML = optionHTML;
        })
        
        this._handleInputEvent();
  }

}
customElements.define('collection-filters-side', CollectionFiltersSide);

class CollectionFiltersSAHDT extends CollectionFilters {

  constructor() {
    super();
    this.initJsonData();
  }

  async initJsonData(){
    let json = await vehicleUtility.tsvSemiAndHeavyTrucksJSON();
    this.initVehicle(json);
    vehicleJson = json;
  }

  initVehicle(json){
    this.vehicleJsonData = json;
    this.defaultMaterial = window.globalVariables.default_material;

    this.uniqueYears = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.year)),
    ];
    this.uniqueMake = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.make))
    ];
    this.uniqueModels = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.model)),
    ];
    this.uniqueRows = [
      ...new Set(Object.values(this.vehicleJsonData).map((item) => item.row))
  ];

    document.querySelectorAll("[data-SAHDT-year-filter]") ? this.yearSelect = document.querySelectorAll("[data-SAHDT-year-filter]") : '';
    document.querySelectorAll("[data-SAHDT-make-filter]") ?  this.makeSelect = document.querySelectorAll("[data-SAHDT-make-filter]") : '';
    document.querySelectorAll("[data-SAHDT-model-filter]") ? this.modelSelect = document.querySelectorAll("[data-SAHDT-model-filter]"): '';
    document.querySelectorAll("[data-SAHDT-part-filter]") ? this.partSelect = document.querySelectorAll("[data-SAHDT-part-filter]"): '';
    document.querySelectorAll("[data-SAHDT-row-filter]") ? this.rowSelect = document.querySelectorAll("[data-SAHDT-row-filter]"): '';

    let yearHTML = '';
    this.uniqueYears.sort().reverse().forEach((years , index) => {
      
      if(years != null){
        yearHTML += `
        <li class="for-check filter__item" data-value="${years}">
        <div class="form-check">
        <label
        for="Filter-year-SAHDT-${index+1}"
        class="form-check-label option-label filter-checkbox"
        title="year"
        >
        <input
        type="radio"
        class="form-check-input m-0 d-none"
        data-value="${years}"
        value="${years}"
        id="Filter-year-SAHDT-${index+1}"
        data-SAHDT-year
        data-label="${years}"
        data-inputSAHDTModel="false"
        >
        ${years}
        </label>
        </div>
        </li>
        `;
      }

      if (this.yearSelect != null) {
        this.yearSelect.forEach( ele => {
          ele.innerHTML = yearHTML
        })
      }
    });

    this._handleInputEvent();
  }

/**
 * Input events
 * 
 */
  _handleInputEvent() {
    let modelInputEle = document.querySelectorAll('[data-inputSAHDTModel]');
    modelInputEle.forEach((ele, index) => {
      ele.addEventListener('click', event => {

        if(ele.hasAttribute('data-SAHDT-year')){
          let currentvalue = ele.getAttribute('data-label');
          selected_year = currentvalue;
          selected_make='' , selected_model='' 

          this.makeSelect.forEach( ele => {
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.classList.add('disabled');
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Make';
          })
          this.modelSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
          })

          this._updateMake(currentvalue);
          this.yearSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })

        }
        else if(ele.hasAttribute('data-make')){
          let currentvalue = ele.getAttribute('data-label');
          selected_make = currentvalue;
          selected_model=''
         
          this.modelSelect.forEach( ele => {
            ele.closest('.custom-dropdown').classList.add('disabled');
            let customDrop = ele.closest('.custom-dropdown');
            customDrop.querySelector('[data-selctedInputValue]').innerHTML = 'Model';

          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.add('disabled');
          }) 
          this._updateModel(currentvalue);
          this.makeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-model')){
          let _this = event.currentTarget; 
          let currentvalue = ele.getAttribute('data-label');
          selected_model = currentvalue;
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          this._updateRow(selected_year , selected_make , selected_model);
          this._updateParts(selected_year , selected_make , selected_model);
          this.modelSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }

        let dataFilter = event.target.closest('[data-filter]').dataset.filter;
        let parents = document.querySelectorAll(`[data-filter="${dataFilter}"]`);
        let formElement = document.querySelector("[data-fixedfilter] #CollectionFiltersForm");

        if (dataFilter && formElement) {
          let elementName = ele.getAttribute("name");
          let existingInputElement = formElement.querySelector(`input[type="hidden"][name="${elementName}"]`);

          if (existingInputElement) {
            let eleVal = ele.getAttribute('data-label');
            existingInputElement.value = eleVal;
          } else {
            let inputElementHTML = `<input type="hidden" name="${elementName}" value="${ele.value}">`;
            formElement.insertAdjacentHTML('afterbegin', inputElementHTML);
          }

          parents.forEach((parent, index) => {
            let selectedValues = parent.querySelectorAll('[data-selctedInputValue]');
            selectedValues.forEach((selectedValue, index) => {
              let elVal = ele.getAttribute('data-label');
              selectedValue.innerHTML = elVal;
            });
          });
        }
      })
    })
  }


  /**
 * 
 * Update the rows
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   * @param {*} trim - selected trim
   * @param {*} cab_type - selected cab type
 */
  _updateRow( year , make , model , trim , cab_type){

    let selectedYear = year;
    let selectedMake = make;
    let selectedModel = model;
    
        let filteredRows;
       filteredRows =
                selectedModel !== ""
                ? [
                    ...new Set(
                        Object.values(this.vehicleJsonData)
                        .filter(
                            (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel 
                        )
                        .map((item) => item.row)
                    ),
                    ]
                : this.uniqueRows;
    
        let optionHTML = "";
    
        filteredRows.sort().forEach((option) => {
          if (option !== null) {
            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="ymm-input form-check-input d-none" data-label="${option}" value="${option}" data-value="${option}" id="year-SAHDT-${option}"/>
                <label class="option_txt form-check-label w-100 text-capitalize" for="year-SAHDT-${option}" title="Label for ${option}">${option}</label>
            </li>`;
          } 
        });
       
        this.rowSelect.forEach( ele => {
          ele.innerHTML = optionHTML;
        })
      }


  /**
   * 
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   */
  _updateParts( year , make , model ){
    let selectedYear = year;
    let selectedMake = make;
    let selectedModel = model;
    let uniquePartNumbers = [];
 
        let filteredParts;
  
        filteredParts = [
          ...new Set(
              Object.values(this.vehicleJsonData)
                  .filter(
                      (item) =>
                          item.year === selectedYear &&
                          item.make === selectedMake &&
                          item.model === selectedModel 
                  )
                  .map((item) => item.part_number)
          ),
      ];
  
      // Add the unique part numbers to the result array
      uniquePartNumbers.push(...filteredParts);

    // Remove duplicates from the result array
    uniquePartNumbers = [...new Set(uniquePartNumbers)];
    selectedPartNumber = uniquePartNumbers;
    localStorage.setItem('partNumbers', JSON.stringify(uniquePartNumbers));

    let optionHTML = "";

    if(uniquePartNumbers.length > 0){
      uniquePartNumbers.sort().forEach((option) => {
        if (option !== null) {
         
          var prefixedParts = selectedPartNumber.map(function(element) {
            return "sku-" + element.toUpperCase();
        });
        var partsNumber = prefixedParts.join(",");
        let partNum = option;
          optionHTML += `
          <li class="for-check" data-value="${option}">
              <input type="checkbox" class="ymm-input form-check-input d-none" data-label="${option}" value="sku-${partNum}" data-value="${option}" id="year-${option}" name="filter.p.tag" checked/>
              <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
          </li>`;
        } 
      });
    }
   
    this.partSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

}

  /**
 * update the models
 */
  _updateModel(){
   let selectedYear = selected_year;
    let selectedMake = selected_make;
    const filteredModels =
      selectedMake !== ""
        ? [
            ...new Set(
              Object.values(this.vehicleJsonData)
                .filter(
                  (item) =>
                    item.year === selectedYear && item.make === selectedMake
                )
                .map((item) => item.model)
            ),
          ]
        : this.uniqueModels;


    let modeloptionHTML ="";
    filteredModels.sort().forEach((option , index) => {
      if (option != null) {
        let optionVal = Utility._createSlug(option);
        modeloptionHTML += `
            <li class="filter__item">
            <div class="form-check">
            <label for="Filter-model-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
            <input type="radio" class="form-check-input m-0 d-none" 
            data-value="${option}" data-label="${option}" value="${optionVal}" id="Filter-model-${index+1}" data-handle="${option}" data-model=""
            data-inputSAHDTModel="true">
            ${option}
            </label>
            </div>
            </li>
        `;
      }
    });
    
    this.modelSelect.forEach( ele => {
      ele.closest('.custom-dropdown').classList.remove('disabled');
      ele.innerHTML = modeloptionHTML;
    })
    this._handleInputEvent();
  }

  /**
   * 
   * @param {*} inputValue - selected year value
   * update the make
   */
  _updateMake(inputValue){
    const selectedYear = inputValue;

    // Filter available options based on user selections
    const filteredMakes = this.uniqueYears.includes(selectedYear)
        ? [
            ...new Set(
            Object.values(this.vehicleJsonData)
                .filter((item) => item.year === selectedYear)
                .map((item) => item.make)
            ),
        ]
        : uniqueYears;
   
        let optionHTML ="";
        filteredMakes.sort().forEach((option , index) => {
          if (option !== null) {
            let optionVal = Utility._createSlug(option)
              optionHTML += `
                <li class="filter__item">
                <div class="form-check">
                <label for="Filter-Make-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
                <input type="radio" class="form-check-input m-0 d-none"
                data-value="${option}" data-label="${option}" value="${optionVal}" id="Filter-Make-${index+1}" data-handle="${option}" data-make=""
                data-inputSAHDTModel="false">
                ${option}
                </label>
                </div>
                </li>
            `;
          }
        });
        
        this.makeSelect.forEach( ele => {
          ele.closest('.custom-dropdown').classList.remove('disabled');
          ele.innerHTML = optionHTML;
        })
        
        this._handleInputEvent();
  }

}
customElements.define('collection-filters-semi-and-heavy-duty-trucks', CollectionFiltersSAHDT);


class CollectionTurfEquipment extends CollectionFilters {

  constructor() {
    super();
    this.tsvTurfJSON();
  }

  async tsvTurfJSON(){
    let json = await vehicleUtility.tsvTurfJSON();
    this.initTurf(json);
  }

  initTurf(json){
  this.turfEquipmentJsonData =  json;

  this.uniqueCategory = [
    ...new Set(Object.values(this.turfEquipmentJsonData).map((item) => item.equipment_category.trim()))
];
this.uniqueManufacture = [
    ...new Set(Object.values(this.turfEquipmentJsonData).map((item) => item.equipment_manufacturer)),
];
this.uniqueModelNumber = [
    ...new Set(Object.values(this.turfEquipmentJsonData).map((item) => item.equipment_model_number)),
];

this.uniqueEquipmentParts = [
    ...new Set(Object.values(this.turfEquipmentJsonData).map((item) => item.equipment_part_number))
];

  this.typeSelect = document.querySelectorAll("[data-turf-equiment-type-filter]");
  this.manufacturerSelect = document.querySelectorAll("[data-turf-manufacturer-filter]");
  this.modelNumberSelect = document.querySelectorAll("[data-turf-model-filter]");
  this.eqPartSelect = document.querySelectorAll('[data-turf-part-filter]');

  let equipTypeHTML =''
  this.uniqueCategory.sort().forEach((category , index) => {
    if(category != null){
      let categoryVal = Utility._createSlug(category);
      equipTypeHTML += `
      <li class=" my-2  filter__item">
      <div class="form-check">
        <label for="Filter-Equipment-Type-${index}" class="form-check-label option-label filter-checkbox" title="${category}">
          <input type="radio" class="form-check-input m-0 d-none" data-label="${category}" data-value="${category}" value="${category}" id="Filter-Equipment-Type-${index}" data-handle="${category}" data-equipment-type data-inputmodel="false">
          ${category}
        </label>
      </div>
    </li>
      `;
    }
  });

  this.typeSelect.forEach( ele => {
  ele.innerHTML = equipTypeHTML
  })

  this._handleInputEvent();

  this.typeSelect.forEach( ele => {
  this.typeInputs = ele.querySelectorAll('input');
  this.typeInputs.forEach((typeInput) => {
    typeInput.addEventListener('change', (event) => {
        this._updateManufacture(selected_equipemnt_type);
    })
  })

  });
  }

  _handleInputEvent(){
    let modelInputEle = document.querySelectorAll('[data-inputModel]');
    modelInputEle.forEach((ele, index) => {
      ele.addEventListener('change', event => {

        if(ele.hasAttribute('data-equipment-type')){
          let currentvalue = ele.getAttribute('data-label');
          let currentvalueLabel = ele.getAttribute('data-label');
          selected_equipemnt_type = currentvalueLabel;
          this.typeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-equipment-manufacturer')){
          let currentvalue = ele.value;
          let currentvalueLabel = ele.getAttribute('data-label');
          selected_eq_manufacturer = currentvalueLabel;
          this._updateEqModel(currentvalueLabel);
          this.manufacturerSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
        }
        else if(ele.hasAttribute('data-model-number')){
          let _this = event.currentTarget;
          let currentvalue = ele.value;
          let currentvalueLabel = ele.getAttribute('data-label');
          selected_eq_model = currentvalueLabel;
          this._updateParts();
          this.modelNumberSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled')
          })
        }


        let dataFilter = event.target.closest('[data-filter]').dataset.filter;
        let parents = document.querySelectorAll(`[data-filter="${dataFilter}"]`);
        let formElement = document.querySelector("[data-fixedfilter] #CollectionFiltersForm");

        if (dataFilter && formElement) {
          let elementName = ele.getAttribute("name");
          let existingInputElement = formElement.querySelector(`input[type="hidden"][name="${elementName}"]`);

          if (existingInputElement) {
            let eleVal = ele.getAttribute('data-label');
            existingInputElement.value = eleVal;
          } else {
            let inputElementHTML = `<input type="hidden" name="${elementName}" value="${ele.value}">`;
            formElement.insertAdjacentHTML('afterbegin', inputElementHTML);
          }

          parents.forEach((parent, index) => {
            let selectedValues = parent.querySelectorAll('[data-selctedInputValue]');
            selectedValues.forEach((selectedValue, index) => {
              let elVal = ele.getAttribute('data-label');
              selectedValue.innerHTML = elVal;
            });
          });
        }
      })
    })
  }

/**
 * 
 * @param {*} inputValue - selected equipment type
 */
_updateManufacture(inputValue){
  let selectedCategory = inputValue;
  // Filter available options based on user selections
  const filteredManufacturer = this.uniqueCategory.includes(selectedCategory)
      ? [
          ...new Set(
          Object.values(this.turfEquipmentJsonData)
              .filter((item) => item.equipment_category.trim() === selectedCategory)
              .map((item) => item.equipment_manufacturer)
          ),
      ]
      : this.uniqueCategory;
  
      let equipManufacturerHTML="";
      this.manufacturerSelect.forEach( ele => {
        ele.innerHTML = '';
      })
      filteredManufacturer.sort().forEach((manufacturer,index) => {
        if(manufacturer != null ){
          let manufactureVal = Utility._createSlug(manufacturer);
            equipManufacturerHTML += `
            <li class=" my-2  filter__item">
            <div class="form-check">
              <label for="Filter-Manufacturer-${index}" class="form-check-label option-label filter-checkbox" title="${manufacturer}">
                <input type="radio" class="form-check-input m-0 d-none" data-label="${manufacturer}" data-value="${manufacturer}" value="${manufacturer}" id="Filter-Manufacturer-${index}" data-handle="${manufacturer}" data-equipment-manufacturer data-inputmodel="false">
                ${manufacturer}
              </label>
            </div>
          </li>
            `;
        }
      });

      this.manufacturerSelect.forEach( ele => {
        ele.closest('.custom-dropdown').classList.remove('disabled')
        ele.innerHTML = equipManufacturerHTML ;
      })
    
      this._handleInputEvent(); 
}
/**
 * 
 * @param {]} inputValue - model value
 */
  _updateEqModel(inputValue){
    let selectedManufacturer = inputValue;
    let filteredModel;
    // Filter available options based on user selections

    if(document.querySelectorAll('[name="filter.p.m.custom.product_equipment_type"]:checked')){
      let selectedCategory = document.querySelector('input[data-equipment-type]:checked').getAttribute('data-label');
       // Filter available options based on user selections
          filteredModel = this.uniqueManufacture.includes(selectedManufacturer)
          ? [
              ...new Set(
              Object.values(this.turfEquipmentJsonData)
                  .filter((item) => item.equipment_manufacturer === selectedManufacturer && item.equipment_category.trim() === selectedCategory)
                  .map((item) => item.equipment_model_number)
              ),
          ]
          : this.uniqueManufacture;
      // Populate the selects with filtered options
  } else {
      // Filter available options based on user selections
      filteredModel = this.uniqueManufacture.includes(selectedManufacturer)
      ? [
          ...new Set(
          Object.values(this.turfEquipmentJsonData)
              .filter((item) => item.equipment_manufacturer === selectedManufacturer)
              .map((item) => item.equipment_model_number)
          ),
      ]
      : this.uniqueManufacture;
      // Populate the selects with filtered options
  }
    this.modelNumberSelect.innerHTML = "";
    let optionHTML = "";
    filteredModel.sort().forEach((option,index) => {
      if (option != null) {

        let optionVal = Utility._createSlug(option)

        optionHTML += `
        <li class=" my-2  filter__item">
        <div class="form-check">
          <label for="Filter-Eqmodel-${index}" class="form-check-label option-label filter-checkbox" title="${option}">
            <input type="radio" class="form-check-input m-0 d-none" data-label="${option}" data-value="${option}" value="${option}" id="Filter-Eqmodel-${index}" data-handle="${option}" data-model-number data-inputmodel="false">
            ${option}
          </label>
        </div>
      </li>
        `;
        this.modelNumberSelect.forEach( ele => {
          ele.closest('.custom-dropdown').classList.remove('disabled')
        })
      }
    });
 
    this.modelNumberSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
     })
    this._handleInputEvent();

}

/**
 * 
 */
_updateParts(){
  let filteredParts;
  let uniquePartNumbers = [];

      // Filter available options based on user selections
      filteredParts = [
          ...new Set(
              Object.values(this.turfEquipmentJsonData)
                  .filter(
                      (item) =>
                          item.equipment_manufacturer == selected_eq_manufacturer &&
                          item.equipment_category == selected_equipemnt_type &&
                          item.equipment_model_number == selected_eq_model
                  )
                  .map((item) => item.equipment_part_number)
          ),
      ];

      uniquePartNumbers.push(...filteredParts);

       // Remove duplicates from the result array
    uniquePartNumbers = [...new Set(uniquePartNumbers)];
    selectedPartNumber = uniquePartNumbers;

    let optionHTML = "";

    if(uniquePartNumbers.length > 0){
      uniquePartNumbers.sort().forEach((option) => {
        if (option !== null) {
          var prefixedParts = selectedPartNumber.map(function(element) {
            return "sku-" + element.toUpperCase();
        });
        var partsNumber = prefixedParts.join(",");
          optionHTML += `
          <li class="for-check" data-value="${option}">
              <input type="checkbox" class="ymm-input form-check-input d-none" data-label="${option}" value="sku-${option}" data-value="${option}" id="year-${option}" name="filter.p.tag" checked/>
              <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
          </li>`;
        } 
      });
    }

    this.eqPartSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

}

}
customElements.define('collection-filters-agri', CollectionTurfEquipment);
class vehicleFilter extends CollectionFilters {

  constructor() {
    super();
    this.initJsonData();
  }

  async initJsonData(){
    let json = await Utility.tsvVehicleJSON();
    this.initVehicle(json);
    vehicleJsonFord = json;
  }

  initVehicle(json){
    this.vehicleJsonFordData = json;
    this.defaultMaterial = window.globalVariables.default_material;

    this.uniqueYears = [
      ...new Set(Object.values(this.vehicleJsonFordData).map((item) => item.year)),
    ];

    this.uniqueTrims = [
      ...new Set(Object.values(this.vehicleJsonFordData).map((item) => item.trim)),
    ];

    this.uniqueCabTypes = [
      ...new Set(Object.values(this.vehicleJsonFordData).map((item) => item.cab_type)),
    ];

    this.uniqueRows = [
      ...new Set(Object.values(this.vehicleJsonFordData).map((item) => item.row))
  ];

    document.querySelectorAll("[data-vehicle-year-filter]") ? this.yearSelect = document.querySelectorAll("[data-vehicle-year-filter]") : '';
    document.querySelectorAll("[data-vehicle-part-filter]") ? this.partSelect = document.querySelectorAll("[data-vehicle-part-filter]"): '';
    document.querySelectorAll("[data-vehicle-row-filter]") ? this.rowSelect = document.querySelectorAll("[data-vehicle-row-filter]"): '';
    document.querySelectorAll("[data-vehicle-trim-filter]") ? this.trimSelect = document.querySelectorAll("[data-vehicle-trim-filter]") : '';
    document.querySelectorAll("[data-vehicle-cab-type-filter]") ?  this.cabTypeSelect = document.querySelectorAll("[data-vehicle-cab-type-filter]") : '';

    selected_model_vehicle = document.querySelector('[data-selectedVehicleModel]').getAttribute('data-value') ;
    selected_make_vehicle  = document.querySelector('[data-selectedVehicleMake]').getAttribute('data-value')
 
    let yearHTML = '';
    this.uniqueYears.sort().reverse().forEach((years , index) => {
      
      if(years != null){
        yearHTML += `
        <li class="for-check filter__item" data-value="${years}">
        <div class="form-check">
        <label
        for="Filter-year-side-${index+1}"
        class="form-check-label option-label filter-checkbox"
        title="year"
        >
        <input
        type="radio"
        class="form-check-input m-0 d-none"
        data-value="${years}"
        value="${years}"
        id="Filter-year-side-${index+1}"
        data-side-year
        data-label="${years}"
        data-inputSideModel="false"
        >
        ${years}
        </label>
        </div>
        </li>
        `;
      }

      if (this.yearSelect != null) {
        this.yearSelect.forEach( ele => {
          ele.innerHTML = yearHTML
        })
      }
    });

    this._handleInputEvent();
  }

/**
 * Input events
 * 
 */
  _handleInputEvent() {
    let modelInputEle = document.querySelectorAll('[data-inputSideModel]');
    let submitEvent  = document.querySelector('[data-fordSubmit]');
    modelInputEle.forEach((ele, index) => {
      ele.addEventListener('click', event => {
        
        if(ele.hasAttribute('data-side-year')){
          let currentvalue = ele.getAttribute('data-label');
          selected_year_vehicle = currentvalue;
          document.querySelectorAll('[data-fordSubmit]').forEach( ele => {
              ele.classList.remove('disabled');
            }) 
          this.yearSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
          this._updateRow();
          this._updateParts();
          this._updateTrim(currentvalue);
        }
        else if(ele.hasAttribute('data-vehicle-trim')){
          let currentvalue = ele.getAttribute('data-label');
          selected_trim_vehicle = currentvalue;
          document.querySelectorAll('[data-fordSubmit]').forEach( ele => {
              ele.classList.remove('disabled');
            }) 
          this.trimSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
          this._updateRow();
          this._updateParts();
          this._updateCabType(currentvalue);
        }
        else if(ele.hasAttribute('data-vehicle-cab-type')){
          let _this = event.currentTarget; 
          let currentvalue = ele.getAttribute('data-label');
          selected_cab_vehicle = currentvalue;
          this.cabTypeSelect.forEach( ele =>{
            this.selectContainer = ele.closest('.custom--select');
            Utility.toggleElement(this.selectContainer, 'close');
          })
          document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
            ele.classList.remove('disabled');
          }) 
          this._updateRow();
          this._updateParts();
        }

        let dataFilter = event.target.closest('[data-filter]').dataset.filter;
        let parents = document.querySelectorAll(`[data-filter="${dataFilter}"]`);

          parents.forEach((parent, index) => {
              let selectedValues = parent.querySelectorAll('[data-selctedInputValue]');
              selectedValues.forEach((selectedValue, index) => {
              let elVal = ele.getAttribute('data-label');
              selectedValue.innerHTML = elVal;
              });
          });

      })
    })
  }

 _updateCabType(trim) {
  let selectedYear = selected_year_vehicle;
  let selectedMake = selected_make_vehicle;
  let selectedModel = selected_model_vehicle;
  let uniqueCabTypes = [
    ...new Set(Object.values(this.vehicleJsonFordData).map((item) => item.cab_type)),
  ];
    const filteredCabTypes =
      selected_trim_vehicle !== ""
        ? [
            ...new Set(
              Object.values(this.vehicleJsonFordData)
                .filter(
                  (item) =>
                    item.year === selectedYear &&
                    item.make === selectedMake &&
                    item.model === selectedModel &&
                    item.trim === trim
                )
                .map((item) => item.cab_type)
            ),
          ]
        : uniqueCabTypes;

  let optionHTML ="";
  filteredCabTypes.sort().forEach((option , index) => {
    if (option !== null) {
        optionHTML += `
          <li class="filter__item">
          <div class="form-check">
          <label for="Filter-vehicle-cab-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
          <input type="radio" class="form-check-input m-0 d-none"
          data-value="${option}" value="${option}" data-label="${option}" id="Filter-vehicle-cab-${index+1}" data-handle="${option}" data-vehicle-cab-type
          data-inputSideModel="false">
          ${option}
          </label>
          </div>
          </li>
      `;
    }
    else{
      document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
        ele.classList.remove('disabled')
      })
    }
  });
  this._handleInputEvent();
  if(filteredCabTypes.length > 0 ){
    this.cabTypeSelect.forEach( ele => {
      ele.closest('.custom-dropdown').classList.remove('disabled');
      ele.innerHTML = optionHTML
    })
  }

  this._handleInputEvent();

}

   /**
   * 
   * @param {*} year - selected year
   * @param {*} make  - selected make
   * @param {*} model - selcted model
   * update the trim
   */
   _updateTrim(year) {
    let selectedYear = year;
    let selectedMake = selected_make_vehicle;
    let selectedModel = selected_model_vehicle;

    const filteredTrims =
      selectedModel !== ""
        ? [
          ...new Set(
            Object.values(this.vehicleJsonFordData)
              .filter(
                (item) =>
                  item.year === selectedYear &&
                  item.make === selectedMake &&
                  item.model === selectedModel
              )
              .map((item) => item.trim)
          ),
        ]
        : uniqueTrims;
        this._handleInputEvent();
    if (filteredTrims.length > 1 && filteredTrims != null) {
      document.querySelectorAll('[data-filter="vehicle-trim"],[data-filter="vehicle-cab-type"]').forEach(ele => {
        ele.classList.remove('d-none');
      })
      let optionHTML ="";
      filteredTrims.sort().forEach((option , index) => {
        if (option !== null) {
          let optionVal = Utility._createSlug(option)
            optionHTML += `
              <li class="filter__item">
              <div class="form-check">
              <label for="Filter-vehicle-Trim-${index+1}" class="form-check-label option-label filter-checkbox" title="${option}">
              <input type="radio" class="form-check-input m-0 d-none" 
              data-value="${option}" value="${option}" data-label="${option}" id="Filter-vehicle-Trim-${index+1}" data-handle="${option}" 
              data-vehicle-trim=""
              data-inputSideModel="false">
              ${option}
              </label>
              </div>
              </li>
          `;
        }
      });
      this.trimSelect.forEach( ele => {
       ele.closest('.custom-dropdown').classList.remove('disabled');
       ele.innerHTML = optionHTML;
      })
    }
    else {
      document.querySelectorAll('[data-filter="vehicle-trim"] , [data-filter="vehicle-cab-type"]').forEach(ele => {
        ele.classList.add('d-none');
      })
      document.querySelectorAll('[data-filterSubmit]').forEach( ele => {
        ele.classList.remove('disabled')
      })
    }

  this._handleInputEvent();
  }


  /**
 * 
 * Update the rows
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   * @param {*} trim - selected trim
   * @param {*} cab_type - selected cab type
 */
  _updateRow(){

    let selectedYear = selected_year_vehicle;
    let selectedMake =  selected_make_vehicle;
    let selectedModel = selected_model_vehicle;
    let selectedTrim = selected_trim_vehicle ;
    let selectedCabType = selected_cab_vehicle;
    
let filteredRows;
if(selectedTrim == '' && selectedCabType == ''){
    filteredRows =
        selectedModel !== ""
        ? [
            ...new Set(
                Object.values(this.vehicleJsonFordData)
                .filter(
                    (item) =>
                    item.year === selectedYear &&
                    item.make === selectedMake &&
                    item.model === selectedModel 
                )
                .map((item) => item.row)
            ),
            ]
        : this.uniqueRows;
} else {
    filteredRows =
        selectedCabType !== ""
        ? [
            ...new Set(
                Object.values(this.vehicleJsonFordData)
                .filter(
                    (item) =>
                    item.year === selectedYear &&
                    item.make === selectedMake &&
                    item.model === selectedModel &&
                    item.trim === selectedTrim &&
                    item.cab_type === selectedCabType
                )
                .map((item) => item.row)
            ),
            ]
        : this.uniqueRows;
}
    
        let optionHTML = "";
    
        filteredRows.sort().forEach((option) => {
          if (option !== null) {
            optionHTML += `
            <li class="for-check" data-value="${option}">
                <input type="radio" class="ymm-input form-check-input d-none" data-label="${option}" value="${option}" data-value="${option}" id="year-ford-${option}"/>
                <label class="option_txt form-check-label w-100 text-capitalize" for="year-ford-${option}" title="Label for ${option}">${option}</label>
            </li>`;
          } 
        });
       
        this.rowSelect.forEach( ele => {
          ele.innerHTML = optionHTML;
        })
      }

  /**
   * 
   * @param {*} year - selected year
   * @param {*} make - selected make
   * @param {*} model - selected model
   */
  _updateParts(){

    let selectedYear = selected_year_vehicle;
    let selectedMake = selected_make_vehicle;
    let selectedModel = selected_model_vehicle;
    let selectedTrim = selected_trim_vehicle ;
    let selectedCabType = selected_cab_vehicle;

    let rowEls = this.querySelectorAll('[data-vehicle-row-filter] li');
    let uniquePartNumbers = [];
    if (rowEls.length > 0) {
        rowEls.forEach((row) => {
            let rowValue = row.getAttribute('data-value');
            let filteredParts;

            if (selectedTrim == '' && selectedCabType == '') {
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonFordData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            } else if(selectedTrim != '' && selectedCabType == ''){
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonFordData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.trim === selectedTrim &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            } else {
                filteredParts = [
                    ...new Set(
                        Object.values(this.vehicleJsonFordData)
                            .filter(
                                (item) =>
                                    item.year === selectedYear &&
                                    item.make === selectedMake &&
                                    item.model === selectedModel &&
                                    item.trim === selectedTrim &&
                                    item.cab_type === selectedCabType &&
                                    item.row === rowValue
                            )
                            .map((item) => item.part_number)
                    ),
                ];
            }

            // Add the unique part numbers to the result array
            uniquePartNumbers.push(...filteredParts);
        });
    }
    else{
        let filteredParts;
  
        if (selectedTrim == '' && selectedCabType == '') {
          filteredParts = [
              ...new Set(
                  Object.values(this.vehicleJsonFordData)
                      .filter(
                          (item) =>
                              item.year === selectedYear &&
                              item.make === selectedMake &&
                              item.model === selectedModel 
                      )
                      .map((item) => item.part_number)
              ),
          ];
      } else if(selectedTrim != '' && selectedCabType == ''){
        filteredParts = [
            ...new Set(
                Object.values(this.vehicleJsonFordData)
                    .filter(
                        (item) =>
                            item.year === selectedYear &&
                            item.make === selectedMake &&
                            item.model === selectedModel &&
                            item.trim === selectedTrim 
                    )
                    .map((item) => item.part_number)
            ),
        ];
      } else {
          filteredParts = [
              ...new Set(
                  Object.values(this.vehicleJsonFordData)
                      .filter(
                          (item) =>
                              item.year === selectedYear &&
                              item.make === selectedMake &&
                              item.model === selectedModel &&
                              item.trim === selectedTrim &&
                              item.cab_type === selectedCabType 
                      )
                      .map((item) => item.part_number)
              ),
          ];
      }
  
      // Add the unique part numbers to the result array
      uniquePartNumbers.push(...filteredParts);
      }

    // Remove duplicates from the result array
    uniquePartNumbers = [...new Set(uniquePartNumbers)];
    selectedPartNumberVehicle = uniquePartNumbers;

    let optionHTML = "";

    if(uniquePartNumbers.length > 0){
      uniquePartNumbers.sort().forEach((option) => {
        if (option !== null) {
         
          var prefixedParts = selectedPartNumberVehicle.map(function(element) {
            return "sku-" + element.toUpperCase();
        });
        var partsNumber = prefixedParts.join(",");
        part_numbers_vehicle = partsNumber;
        let partNum = option.toLowerCase();
          optionHTML += `
          <li class="for-check" data-value="${option}">
              <input type="checkbox" class="ymm-input form-check-input d-none" data-label="${option}" value="sku-${partNum}" data-value="${option}" id="year-${option}" name="filter.p.tag" checked/>
              <label class="option_txt form-check-label w-100 text-capitalize" for="year-${option}" title="Label for ${option}">${option}</label>
          </li>`;
        } 
      });
    }
                                                                          
    this.partSelect.forEach( ele => {
      ele.innerHTML = optionHTML;
    })

}
}

customElements.define('vehicle-filter', vehicleFilter);